import { useState, useEffect, useRef } from "react";
import { Box, Button, Flex, Icon } from "@chakra-ui/react";
import Link from "next/link";
// Icones
import { ChevronDown } from 'lucide-react';
// import { IoIosArrowDown } from "react-icons/io";
//components 
import { CustomDialog } from "components/ui/dialog";
// Styles
import { HeaderComponentsStyles } from "styles/headerStyles";
// Data
import { institucionalItemsDesktopData, menuItemsData } from "data/siteData";

const handleConfirm = () => {
  window.open(menuItemsData[1].href, "_blank");
};

export const DesktopNavLinks = () => {
    const [isDialogOpen, setIsDialogOpen] = useState(false); 
    const [isOpen, setIsOpen] = useState(false);
    const collapseRef = useRef<HTMLDivElement>(null);
    const [isLoading, setIsLoading] = useState(false);

    const handleClubLinkClick = () => {
      setIsDialogOpen(true);
    };

    useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
        if (isOpen && collapseRef.current && !collapseRef.current.contains(event.target as Node) && !(event.target as Element).closest('[data-chakra-ui-focus-lock]')) {
          setIsOpen(false);
        }
      };
  
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [isOpen]);
    
    const handleLinkClick = (href: string) => {
      setIsLoading(true);
      setTimeout(() => {
        window.location.href = href;
      }, 100);
    };

    const handleBenefitsClick = () => {
      setIsLoading(true);
      setTimeout(() => {
        setIsLoading(false);
        handleClubLinkClick();
      }, 100);
    };
  
    return (
      <>
        <Box {...HeaderComponentsStyles.navLinkDesktop.desktopNavLinksBox}>
          <Box
            position="relative"
            ref={collapseRef}
            onMouseEnter={() => setIsOpen(true)}
            onMouseLeave={() => setIsOpen(false)}
          >
            <Button
              {...HeaderComponentsStyles.navLinkDesktop.desktopNavLinkButton}
              _hover={{ transform: "scale(1.05)", color: "red.700" }}
              color={isOpen ? "red.700" : "black"}
              transform={isOpen ? "scale(1.05)" : "none"}
            >
              Institucional
              <Icon as={ChevronDown} ml={2} boxSize={4} />
            </Button>

            {isOpen && (
              <Box {...HeaderComponentsStyles.navLinkDesktop.collapsibleContentStyles} position="absolute" top="100%" left={0} zIndex={999}>
                {institucionalItemsDesktopData.map((item) => (
                  <Link key={item.label} href={item.href} passHref legacyBehavior>
                    <Flex 
                      as="a" 
                      {...HeaderComponentsStyles.navLinkDesktop.collapsibleItemStyles}
                      onClick={(e) => {
                        e.preventDefault();
                        setIsLoading(true);
                        setTimeout(() => {
                          window.location.href = item.href;
                        }, 800);
                      }}
                    >
                      <Box {...HeaderComponentsStyles.navLinkDesktop.collapsibleItemLabelStyles}>{item.label}</Box>
                      <Box {...HeaderComponentsStyles.navLinkDesktop.collapsibleItemDescriptionStyles}>{item.description}</Box>
                    </Flex>
                  </Link>
                ))}
              </Box>
            )}
          </Box>
          {menuItemsData
            .filter(({ label }) => label !== "Consultar Associado")
            .map(({ label, href }) => (
              label === "Clube de Benefícios" ? (
                <Button key={label} onClick={handleBenefitsClick} {...HeaderComponentsStyles.navLinkDesktop.desktopNavLinkButton}>
                  {label}
                </Button>
              ) : (
                <Button 
                  key={label} 
                  onClick={() => handleLinkClick(href)} 
                  {...HeaderComponentsStyles.navLinkDesktop.desktopNavLinkButton}
                >
                  {label}
                </Button>
              )
          ))}
          <CustomDialog
            open={isDialogOpen}
            onClose={() => setIsDialogOpen(false)}
            title="COMUNICADO IMPORTANTE"
            titleBg="orange.500"
            body="A AAJUMP esclarece que tem formalizado alguns convênios com prestadores de serviços e/ou empresas com intuito de gerar benefícios para os seus associados. Porém, nossa associação não tem qualquer responsabilidade pela prestação de serviço ou aquisição de produtos dos conveniados, sendo a contratação de inteira responsabilidade do associado."
            body2="Ao concordar, você será redirecionado para a nossa página de convênios chamada Clube de Benefícios."
            onConfirm={() => {
              setIsLoading(true);
              handleConfirm();
            }}
            onCancel={() => setIsDialogOpen(false)}
          />
        </Box>
      </>
    );
};